// extracted by mini-css-extract-plugin
module.exports = {"upload_des":"CoverImageUpload_style_upload_des__2PfnO","upload_add":"CoverImageUpload_style_upload_add__cBENy","text_desc":"CoverImageUpload_style_text_desc__O6hzQ"};